import React from "react";
import BackButton from "./BackButton";
import { Skeleton } from "./Needed";

const Loading = ({ backLabel = "to List" }) => (
    <div className="container-fluid">
        <BackButton name={backLabel} />
        <div className="card p-4 rounded-4 shadow-sm mt-3">
            <div className="d-flex gap-4">
                <div className="flex-grow-1">
                    <Skeleton height={30} width="50%" className="mb-3" />
                    <Skeleton height={20} width="30%" className="mb-2" />
                    <Skeleton height={20} width="40%" className="mb-2" />
                    <Skeleton height={20} width="35%" />
                </div>
            </div>
        </div>
        <div className="row mt-4">
            <div className="col-lg-8">
                <Skeleton height={300} className="mb-4" />
                <Skeleton height={300} className="mb-4" />
            </div>
            <div className="col-lg-4">
                <Skeleton height={400} />
            </div>
        </div>
    </div>
);

export default Loading;
